/**
 * Represents the allowed heading levels in Markdown
 */
export type MarkdownHeadingLevel = 1 | 2| 3 | 4 | 5;